/**
 * Returns the rank of the category in the filter order.
 *
 * @param filterOrder Order in which filters should be displayed
 * @param categoryName Category name
 * @returns the rank of the category in the filter order
 */
export default function filterOrderRank(
  filterOrder: string[],
  categoryName: string
): number {
  const index = filterOrder.indexOf(categoryName);
  return index === -1 ? filterOrder.length : index;
}
